import React,
{
    useState
}
from "react";

import AssessmentQuestion
    from "./AssessmentQuestion";

export default function BuildingBookAssetCondition()
{
    const [conditions,
        setConditions] =
            useState(
            {
                electrical: "Good",

                mechanical: "Fair",

                cosmetic: "Poor",

                cleanliness: "Good",

                accessibility: "Excellent",

                healthSafety: "Good"
            });

    const options =
    [
        {
            label: "Excellent",

            gradient:
                "linear-gradient(180deg,#2fa56f 0%,#15803d 100%)"
        },

        {
            label: "Good",

            gradient:
                "linear-gradient(180deg,#5fbf4a 0%,#4d9f34 100%)"
        },

        {
            label: "Fair",

            gradient:
                "linear-gradient(180deg,#e6a21a 0%,#b45309 100%)"
        },

        {
            label: "Poor",

            gradient:
                "linear-gradient(180deg,#e05252 0%,#b91c1c 100%)"
        },

        {
            label: "Critical",

            gradient:
                "linear-gradient(180deg,#8b1e1e 0%,#5c1010 100%)"
        }
    ];

    function updateCondition(
        key,
        value
    )
    {
        setConditions(
        {
            ...conditions,

            [key]: value
        });
    }

    return (

        <div>

            <div style={header}>
                Condition Assessment
            </div>

            <AssessmentQuestion
                title="Electrical"
                value={conditions.electrical}
                options={options}
                setValue={
                    function(value)
                    {
                        updateCondition(
                            "electrical",
                            value
                        );
                    }
                }
            />

            <AssessmentQuestion
                title="Mechanical"
                value={conditions.mechanical}
                options={options}
                setValue={
                    function(value)
                    {
                        updateCondition(
                            "mechanical",
                            value
                        );
                    }
                }
            />

            <AssessmentQuestion
                title="Cosmetic"
                value={conditions.cosmetic}
                options={options}
                setValue={
                    function(value)
                    {
                        updateCondition(
                            "cosmetic",
                            value
                        );
                    }
                }
            />

            <AssessmentQuestion
                title="Cleanliness"
                value={conditions.cleanliness}
                options={options}
                setValue={
                    function(value)
                    {
                        updateCondition(
                            "cleanliness",
                            value
                        );
                    }
                }
            />

            <AssessmentQuestion
                title="Accessibility"
                value={conditions.accessibility}
                options={options}
                setValue={
                    function(value)
                    {
                        updateCondition(
                            "accessibility",
                            value
                        );
                    }
                }
            />

            <AssessmentQuestion
                title="Health & Safety"
                value={conditions.healthSafety}
                options={options}
                setValue={
                    function(value)
                    {
                        updateCondition(
                            "healthSafety",
                            value
                        );
                    }
                }
            />

            <div style={scoreContainer}>

                Overall Score

                <div style={scoreValue}>
                    78%
                </div>

            </div>

            <div style={notesContainer}>

                <div style={notesLabel}>
                    Notes
                </div>

                <textarea
                    style={notes}
                    placeholder="Enter survey notes..."
                />

            </div>

            <button style={saveButton}>
                Save Assessment
            </button>

        </div>
    );
}


const header =
{
    fontSize: "22px",

    fontWeight: "600",

    marginBottom: "30px"
};

const scoreContainer =
{
    marginTop: "30px",

    padding: "20px",

    background:
        "linear-gradient(180deg,#f8f9fb 0%,#eef1f5 100%)",

    borderRadius: "10px",

    textAlign: "center",

    border:
        "1px solid rgba(0,0,0,0.05)"
};

const scoreValue =
{
    fontSize: "36px",

    fontWeight: "700",

    color: "#5a9bd6",

    marginTop: "8px"
};

const notesContainer =
{
    marginTop: "30px"
};

const notesLabel =
{
    marginBottom: "10px",

    fontWeight: "600"
};

const notes =
{
    width: "100%",

    height: "140px",

    border:
        "1px solid #dcdcdc",

    borderRadius: "8px",

    padding: "12px",

    resize: "vertical",

    fontFamily: "inherit",

    background: "#ffffff"
};

const saveButton =
{
    marginTop: "20px",

    padding: "12px 24px",

    border: "0px",

    borderRadius: "22px",

    background:
        "linear-gradient(180deg,#5a9bd6 0%,#417fb7 100%)",

    color: "#fff",

    cursor: "pointer",

    fontWeight: "600",

    boxShadow:
        "0 8px 20px rgba(0,0,0,0.20)"
};